export const COPY = {
    SUPPORTEDBY: `The CLARK System is partially supported by California State University through HQ0034251E002 under the DoW Cyber Academic Engagement Office,
     the NSF NCyTE Center, NSA NCAE-C program (H98230-21-1-0175), NCCP program (H9830-17-1-0405) and Towson University.`,
    TEAM: "Meet the Team",
    USAGE: "Usage Statistics",
    HELP: "Ask for Help",
    TUTORIAL: "Tutorial",
    TERMS: "Terms of Service",
    ACCESSIBILITY: "Accessibility",
    PRESS: "Press and Media",
    ABOUT: "About CLARK",
    SUBSCRIBE: "Sign up for our Newsletter",
    ROADMAP: "Roadmap",
    PRIVACY: "Privacy Policy",
    BLOG: "Blogs",
};
